// this is an autogenerated file from App/Account/Content/Settings/Content/CommsEmail/mutation-set-default.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__App_Account_Content_Settings_Content_CommsEmail($defaults: [comms_defaults_insert_input!]!) {
  insert_comms_defaults(objects: $defaults) {
    affected_rows
  }
}

`